import userActionsActionType from 'actions/userActions/userActionsActionType';

const initialState = {
  userActions: null,
  userRecentActions: null,
};

const userActionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case userActionsActionType.SAVE_USER_ACTIONS:
    return {
      ...state,
      userActions: payload.data,
    };
  case userActionsActionType.RESET_USER_ACTIONS:
    return {
      ...state,
      userActions: null,
    };
  case userActionsActionType.SAVE_USER_RECENT_ACTIONS:
    return {
      ...state,
      userRecentActions: payload.data,
    };
  case userActionsActionType.RESET_USER_RECENT_ACTIONS:
    return {
      ...state,
      userRecentActions: null,
    };

  default:
    return state;
  }
};

export default userActionsReducer;
